<template>
  <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
    <font-awesome-icon icon="recycle"/>&nbsp;{{ $t('extend') }}
    <b-modal v-model="showForm" :title="$t('extend')" no-close-on-backdrop no-enforce-focus size="xs">
      <div v-if="client" class="alert alert-info">
        <p><span><b>{{ $t('currentChatbotPackageLimit') }}: </b></span>{{ client.chatbotLimit }}</p>
        <p><span><b>{{
            $t('packageExpireTime')
          }}: </b></span>{{ client.chatbotExpireTime | moment('DD/MM/YYYY HH:mm:ss') }}</p>
        <div><span><b>{{ $t('currentCreditBalance') }}: </b></span>{{ client.creditBalance | numFormat }}</div>
      </div>
      <client-select v-if="showForm" :label="$t('client')" :model="formModel" attribute="client"
                     :is-chatbot="true" :errors="formErrors"></client-select>
      <form-input :label="$t('numberOfUser')" attribute="limit" :model="formModel"
                  :errors="formErrors"></form-input>
      <div class="mb-3">
        <div class="mb-2">{{ $t('extendTo') }}</div>
        <time-picker :model="formModel" :errors="formErrors" :label="$t('endMonth')" attribute="endMonth"
                     unit="month"></time-picker>
      </div>
      <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
      <client-user-select :disabled="!formModel.client" :model="formModel" attribute="manager"
                          :label="$t('managerAccount')"
                          :client-filter="formModel.client" :place-holder="$t('selectManager')"
                          :errors="formErrors"></client-user-select>
      <hr>
      <p v-if="monthCount" class="text-right"><b>{{ $t('countFromDate') }}</b>:
        <span>{{ startTime | moment('DD/MM/YYYY') }}</span></p>
      <p class="text-right"><b>{{ $t('numberOfUser') }}</b>: <span
          class="text-success">{{ formModel.limit && formModel.limit > 0 ? formModel.limit : 0 }}</span></p>
      <p class="text-right"><b>{{ $t('numberOfMonth') }}</b>: <span class="text-success">{{ monthCount }}</span></p>
      <p class="text-right"><b>{{ $t('packagePricePerMonth') }}</b>: <span class="text-success">{{
          chatbotFee | numFormat
        }}</span></p>
      <p class="text-right"><b>{{ $t('total') }}</b>: <span class="text-danger">{{ total | numFormat }}</span></p>
      <template v-slot:modal-footer>
        <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
        <button
            :disabled="!total || total <= 0 || !formModel.client || !['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
            class="btn btn-primary float-right"
            @click="purchase()">
          {{ $t('savePlanOrder') }}
        </button>
      </template>
    </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import moment from "moment";
import TimePicker from "@/components/TimePicker.vue";
import ClientUserSelect from "@/components/ClientUserSelect.vue";

export default {
  components: {ClientUserSelect, TimePicker, ClientSelect},
  props: ['chatbotFee'],
  mixins: [CRUD],
  data: function () {
    return {
      service: '/client-chatbot',
      defaultFormModel: {
        client: null,
        limit: 1,
        endMonth: moment(Date.now()).endOf('month'),
        note: null,
        manager: null,
      },
      client: null
    }
  },
  watch: {
    "formModel.client": {
      handler(val) {
        if (this.showForm && val) {
          this.updateInvoiceEnabled();
        } else {
          this.formModel.invoiceEnabled = false
          this.client = null
          this.formModel.manager = null
        }
      }
    },
  },
  methods: {
    open: function () {
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
    },
    purchase() {
      let loader = this.$loading.show();
      this.$service({url: '/client-chatbot/extend/', method: 'post', data: this.formModel}).then(response => {
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('clientChatbot');
          this.showForm = false;
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    updateInvoiceEnabled() {
      this.$service.get('/client/' + this.formModel.client).then(response => {
        if (response) {
          this.formModel.manager = response.data.chatbotManager ? response.data.chatbotManager : null
          this.formModel.invoiceEnabled = response.data.manualInvoiceEnabled
          this.client = response.data
        }
      })
    },
  },
  computed: {
    monthCount() {
      if (this.formModel.endMonth) {
        let start = moment(this.startTime).startOf('month');
        let end = moment(this.formModel.endMonth).endOf('month');
        let diff = moment(end + 1).diff(start, 'months');
        if (moment(this.startTime).date() >= 15) {
          diff -= 0.5
        }
        return diff && diff > 0 ? diff : 0
      }
      return 0
    },
    total() {
      if (this.formModel.endMonth && this.monthCount > 0 && this.formModel.limit && this.formModel.limit > 0) {
        return this.monthCount * this.formModel.limit * this.chatbotFee
      }
      return 0
    },
    startTime() {
      if (!this.client) return Date.now()
      return this.client.chatbotExpireTime < Date.now() ? Date.now() : this.client.chatbotExpireTime + 1;
    },
  },
  i18n: {
    messages: {
      vi: {
        extend: 'Gia hạn',
        packagePricePerMonth: 'Giá/nhân viên AI/tháng',
        numberOfUser: 'Số nhân viên AI',
        numberOfMonth: 'Số tháng',
        note: 'Ghi chú',
        total: 'Thành tiền',
        cancel: 'Huỷ',
        savePlanOrder: 'Lưu đơn hàng',
        managerAccount: 'Tài khoản quản lý',
        selectManager: 'Chọn tài khoản quản lý',
        packageExpireTime: 'Hạn sử dụng gói',
        extendTo: 'Gia hạn đến',
        endMonth: 'Đến hết tháng',
        currentChatbotPackageLimit: 'Số nhân viên AI đã mua',
        countFromDate: 'Tính từ ngày',
        currentCreditBalance: 'Số dư',
      },
      en: {
        extend: 'Extend',
        packagePricePerMonth: 'Price/AI agent/month',
        numberOfUser: 'Number of AI agents',
        numberOfMonth: 'Number of months',
        note: 'Note',
        total: 'Total',
        cancel: 'Cancel',
        savePlanOrder: 'Save plan order',
        managerAccount: 'Management account',
        selectManager: 'Select management account',
        packageExpireTime: 'Package expiration time',
        extendTo: 'Extended to',
        endMonth: 'By the end of',
        currentChatbotPackageLimit: 'Number of AI agents purchased',
        countFromDate: 'Count from date',
        currentCreditBalance: 'Balance',
      }
    }
  }
}
</script>